/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { getRecentRecords } from './asyncThunks'

const initialState = {
  intros: [],
  recentDashboards: [],
  recentAnalyses: [],
  status: 'idle', // idle|loading|succeeded|failed
  error: null
}

const recentRecordsSlice = createSlice({
  name: 'recentRecords',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRecentRecords.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(getRecentRecords.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.recentDashboards = action.payload.dashboards
        state.recentAnalyses = action.payload.analyses
        state.intros = action.payload.intros
      })
      .addCase(getRecentRecords.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
  }
})

export default recentRecordsSlice.reducer
